import moment from 'moment';

/**
 * Stripe pre-authorization holds last up to 7 days. Until we negotiate a longer
 * hold window for connected hosts, we block pre-auth on bookings whose stay
 * exceeds this window, otherwise the hold would release while the guest is still
 * in stay.
 */
export const PRE_AUTH_MAX_NIGHTS = 7;

/**
 * Whether a booking's length of stay exceeds the pre-auth hold window.
 *
 * @param {string} checkInDate - check-in date (any moment-parseable value)
 * @param {string} checkOutDate - check-out date (any moment-parseable value)
 * @returns {boolean} true when (check-out - check-in) is more than PRE_AUTH_MAX_NIGHTS nights.
 *   Returns false for missing/invalid/malformed dates so the feature fails open
 *   (gating is enforced server-side; this is a UX guard only).
 */
export const isStayBeyondPreAuthWindow = (checkInDate, checkOutDate) => {
  if (!checkInDate || !checkOutDate) return false;

  const checkIn = moment(checkInDate).startOf('day');
  const checkOut = moment(checkOutDate).startOf('day');
  if (!checkIn.isValid() || !checkOut.isValid()) return false;

  const nights = checkOut.diff(checkIn, 'days');
  return nights > PRE_AUTH_MAX_NIGHTS;
};
